import { graphql } from 'gql.tada';

export const GET_BUYERS = graphql(`
    query searchBuyers($limit: Int, $offset: Int, $orderBy: BuyerOrderBy, $contactEmail: String, $contactName: String, $sku: Int, $legalName: String, $publicName: String, $asAdmin: Boolean! = false) {
        searchBuyers(limit: $limit, offset: $offset, orderBy: $orderBy, contactEmail: $contactEmail, contactName: $contactName, sku: $sku, legalName: $legalName, publicName: $publicName) {
            count
            buyers {
                billingEmail
                broadcastLanguage
                broadcastCountries {
                    countries
                    main
                }
                broadcastType
                contactEmail
                contactName
                hourCost
                identifier {
                    id
                    sku
                }
                legalName
                licensesDuration
                payoutTemplate
                postalAddress
                publicName
                replayRights @include(if: $asAdmin)
                vatId
                videoOutputBitrate
                videoOutputFormat
                businessProvider {
                    identifier {
                        sku
                        id
                    }
                    contactName
                }
            }
        }
    }

`);

export const GET_BUYER = graphql(`
    query buyer($id: UUID!, $asAdmin: Boolean! = false) {
        buyer(id: $id) {
            contactEmail
            contactName
            identifier {
                id
                sku
            }
            legalName
            postalAddress
            publicName
            replayRights @include(if: $asAdmin)
            videoOutputBitrate
            videoOutputFormat
            billingEmail
            broadcastLanguage
            vatId
        }
    }

`);

export const GET_BUYER_SUMMARY = graphql(`
    query buyerSummary($id: UUID!) {
        buyer(id: $id) {
            identifier {
                id
            }
            legalName
            publicName
            contactName
            broadcastLanguage
            videoOutputBitrate
            videoOutputFormat
            broadcastCountries {
                countries
                main
            }
            payinIban
        }
    }

`);

export const UPDATE_BUYER = graphql(`
    mutation updateBuyer(
        $id: String!,
        $billingEmail: String,
        $broadcastLanguage: LanguageISOCode,
        $broadcastCountries: BroadcastCountriesInput,
        $broadcastType: BuyerBroadcastType,
        $businessProviderId: String,
        $contactEmail: String,
        $contactName: String,
        $hourCost: Float,
        $payoutTemplate: String,
        $legalName: String,
        $licensesDuration: Int,
        $postalAddress: String,
        $publicName: String,
        $replayRights: Boolean,
        $vatId: String,
        $videoOutputBitrate: BuyerVideoOutputBitrate,
        $videoOutputFormat: BuyerVideoOutputFormat,
        $cognitoPassword: String,
    ) {
        updateBuyer(
            billingEmail: $billingEmail,
            broadcastLanguage: $broadcastLanguage,
            broadcastCountries: $broadcastCountries,
            broadcastType: $broadcastType,
            businessProviderId: $businessProviderId,
            contactEmail: $contactEmail,
            contactName: $contactName,
            hourCost: $hourCost,
            payoutTemplate: $payoutTemplate,
            id: $id,
            legalName: $legalName,
            licensesDuration: $licensesDuration,
            postalAddress: $postalAddress,
            publicName: $publicName,
            replayRights: $replayRights,
            vatId: $vatId,
            videoOutputBitrate: $videoOutputBitrate,
            videoOutputFormat: $videoOutputFormat,
            cognitoPassword: $cognitoPassword,
        ) {
            identifier {
                id
                sku
            }

        }
    }
`);

export const CREATE_BUYER = graphql(`
    mutation createBuyer(
        $billingEmail: String!,
        $broadcastLanguage: LanguageISOCode!,
        $broadcastCountries: BroadcastCountriesInput!,
        $broadcastType: BuyerBroadcastType!,
        $businessProviderId: String,
        $contactEmail: String!,
        $contactName: String!,
        $hourCost: Float,
        $payoutTemplate: String!,
        $legalName: String!,
        $licensesDuration: Int,
        $postalAddress: String!,
        $publicName: String!,
        $replayRights: Boolean,
        $vatId: String!,
        $videoOutputBitrate: BuyerVideoOutputBitrate!,
        $videoOutputFormat: BuyerVideoOutputFormat!,
    ) {
        createBuyer(
            billingEmail: $billingEmail,
            broadcastLanguage: $broadcastLanguage,
            broadcastCountries: $broadcastCountries,
            broadcastType: $broadcastType,
            businessProviderId: $businessProviderId,
            contactEmail: $contactEmail,
            contactName: $contactName,
            hourCost: $hourCost,
            payoutTemplate: $payoutTemplate,
            legalName: $legalName,
            licensesDuration: $licensesDuration,
            postalAddress: $postalAddress,
            publicName: $publicName,
            replayRights: $replayRights,
            vatId: $vatId,
            videoOutputBitrate: $videoOutputBitrate,
            videoOutputFormat: $videoOutputFormat,
        ) {
            identifier {
                id
                sku
            }
        }
    }
`);
